var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _path9, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthyCooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 139,
    viewBox: "0 0 269 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153 139C128.699 139 109 119.301 109 95C109 70.6995 128.699 51 153 51C177.301 51 197 70.6995 197 95C197 119.301 177.301 139 153 139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 131C94.6995 131 75 111.301 75 87C75 62.6995 94.6995 43 119 43C143.301 43 163 62.6995 163 87C163 111.301 143.301 131 119 131Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169 121C142.49 121 121 99.5097 121 73C121 46.4903 142.49 25 169 25C195.51 25 217 46.4903 217 73C217 99.5097 195.51 121 169 121Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 89C127.699 89 108 69.3005 108 45C108 20.6995 127.699 1 152 1C176.301 1 196 20.6995 196 45C196 69.3005 176.301 89 152 89Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 111C91.2812 111 68 87.7188 68 59C68 30.2812 91.2812 7 120 7C148.719 7 172 30.2812 172 59C172 87.7188 148.719 111 120 111Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 266 59)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 4 57)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 50 133)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 47 0)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 249 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 234 133)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L37.5 28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102.5L21 107.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 100.5L247.5 104.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 28.5L267 26",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_8343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 119C171.719 119 195 95.7188 195 67C195 38.2812 171.719 15 143 15C114.281 15 91 38.2812 91 67C91 95.7188 114.281 119 143 119Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 51H169V85C169 87.2091 167.209 89 165 89H121C118.791 89 117 87.2091 117 85V51Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 49H117C117 49 128.641 43 143 43C157.359 43 169 49 169 49Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 63V55H175C176.105 55 177 55.8954 177 57C177 58.1046 176.105 59 175 59H173L169 63Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 63V55H111C109.895 55 109 55.8954 109 57C109 58.1046 109.895 59 111 59H113L117 63Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 41,
    r: 4,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 89.5266C147 86.9361 143 84 143 84C143 84 139 86.9361 139 89.5266C139 95.4911 147 95.4911 147 89.5266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 89.5266C135 86.9361 131 84 131 84C131 84 127 86.9361 127 89.5266C127 95.4911 135 95.4911 135 89.5266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 89.5266C159 86.9361 155 84 155 84C155 84 151 86.9361 151 89.5266C151 95.4911 159 95.4911 159 89.5266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 43,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 34,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 51H159V62C159 63.6569 157.657 65 156 65C154.343 65 153 63.6569 153 62V51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 51H157V55C157 57.2091 155.209 59 153 59C150.791 59 149 57.2091 149 55V51Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10819_8343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8924 99.4578C92.3352 98.6485 104.198 85.4736 103.389 70.0308C102.579 54.588 89.4044 42.7253 73.9616 43.5346C58.5188 44.3439 46.6561 57.5188 47.4654 72.9616C48.2747 88.4044 61.4497 100.267 76.8924 99.4578Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9951 63.625L88.9567 62.1596L89.8183 78.5986C89.9339 80.8047 88.2392 82.6868 86.0331 82.8024L66.0605 83.8492C63.8544 83.9648 61.9723 82.2701 61.8566 80.064L60.9951 63.625Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9002 61.0842L60.9386 62.5496C60.9386 62.5496 67.029 58.9952 74.7503 58.5905C82.4717 58.1859 88.9002 61.0842 88.9002 61.0842Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2948 68.6123L89.0693 64.3105L92.2957 64.1415C92.8896 64.1103 93.3964 64.5666 93.4275 65.1605C93.4586 65.7545 93.0024 66.2612 92.4084 66.2924L91.333 66.3487L89.2948 68.6123Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3338 70.0782L61.1084 65.7764L57.8821 65.9455C57.2881 65.9766 56.8318 66.4833 56.863 67.0773C56.8941 67.6712 57.4008 68.1275 57.9948 68.0963L59.0702 68.04L61.3338 70.0782Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.6943,
    cy: 57.5157,
    rx: 2.15385,
    ry: 2.15385,
    transform: "rotate(-3 74.6943 57.5157)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2128 83.4971C78.1398 82.1041 75.9062 80.638 75.9062 80.638C75.9062 80.638 73.838 82.3295 73.911 83.7225C74.0791 86.9297 78.3809 86.7043 78.2128 83.4971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7597 83.8349C71.6867 82.442 69.4531 80.9759 69.4531 80.9759C69.4531 80.9759 67.3849 82.6674 67.4579 84.0604C67.626 87.2676 71.9278 87.0422 71.7597 83.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.665 83.1582C84.592 81.7652 82.3583 80.2991 82.3583 80.2991C82.3583 80.2991 80.2902 81.9906 80.3632 83.3836C80.5313 86.5909 84.8331 86.3654 84.665 83.1582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6943,
    cy: 59.3794,
    rx: 1.07692,
    ry: 1.07692,
    transform: "rotate(-3 59.6943 59.3794)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.0542,
    cy: 54.4558,
    r: 0.538462,
    transform: "rotate(-3 61.0542 54.4558)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3535 62.6104L83.5799 62.4413L83.8898 68.3562C83.9365 69.2472 83.2521 70.0072 82.3612 70.0539V70.0539C81.4703 70.1006 80.7102 69.4162 80.6635 68.5253L80.3535 62.6104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2021 62.7236L82.5039 62.4982L82.6167 64.6491C82.6789 65.837 81.7664 66.8504 80.5785 66.9127V66.9127C79.3906 66.975 78.3771 66.0624 78.3149 64.8745L78.2021 62.7236Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10819_8343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.921 67.0763C189.291 68.3091 174 55.0165 172.767 37.3865C171.534 19.7564 184.827 4.46502 202.457 3.23221C220.087 1.99939 235.378 15.292 236.611 32.922C237.844 50.5521 224.551 65.8435 206.921 67.0763Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.963 24.2158L188.041 26.448L189.393 45.7854C189.547 47.9892 191.459 49.6508 193.662 49.4967L217.604 47.8225C219.808 47.6684 221.469 45.757 221.315 43.5532L219.963 24.2158Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.956 25.2202L219.878 22.988C219.878 22.988 212.474 19.8044 203.659 20.4208C194.844 21.0372 187.956 25.2202 187.956 25.2202Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.556 33.8144L188.213 28.9033L184.53 29.1609C183.851 29.2083 183.34 29.7964 183.388 30.4745C183.435 31.1526 184.023 31.6638 184.701 31.6164L185.929 31.5306L188.556 33.8144Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.478 31.583L220.135 26.6719L223.818 26.4143C224.496 26.3669 225.084 26.8782 225.132 27.5562C225.179 28.2343 224.668 28.8224 223.99 28.8699L222.762 28.9557L220.478 31.583Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.46154,
    cy: 2.46154,
    rx: 2.46154,
    ry: 2.46154,
    transform: "matrix(-0.997564 0.0697565 0.0697565 0.997564 205.856 16.5664)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.201 49.1549C203.089 47.5646 205.419 45.5905 205.419 45.5905C205.419 45.5905 208 47.2212 208.112 48.8115C208.368 52.473 203.457 52.8164 203.201 49.1549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.567 48.6393C210.456 47.049 212.785 45.0748 212.785 45.0748C212.785 45.0748 215.367 46.7056 215.478 48.2959C215.734 51.9574 210.823 52.3008 210.567 48.6393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.833 49.6696C195.722 48.0793 198.052 46.1051 198.052 46.1051C198.052 46.1051 200.633 47.7358 200.744 49.3261C201.001 52.9876 196.089 53.3311 195.833 49.6696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.23077,
    cy: 1.23077,
    r: 1.23077,
    transform: "matrix(-0.997564 0.0697565 0.0697565 0.997564 221.989 17.9053)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.615385,
    cy: 0.615385,
    rx: 0.615385,
    ry: 0.615385,
    transform: "matrix(-0.997564 0.0697565 0.0697565 0.997564 219.19 13.166)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.863 25.7617L194.18 26.0193L194.652 32.772C194.723 33.7891 195.605 34.556 196.623 34.4849V34.4849C197.64 34.4138 198.407 33.5316 198.335 32.5145L197.863 25.7617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.319 25.5898L195.408 25.9333L195.58 28.3888C195.675 29.745 196.851 30.7675 198.207 30.6726V30.6726C199.563 30.5778 200.586 29.4015 200.491 28.0454L200.319 25.5898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_8343"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 15,
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10819_8343"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 45,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 46 45)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10819_8343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    transform: "matrix(-0.997564 0.0697565 0.0697565 0.997564 234.379 1)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyCooking);
export default __webpack_public_path__ + "static/media/healthy-cooking.4e39f6857c265037e639601fc2337149.svg";
export { ForwardRef as ReactComponent };